import * as React from 'react';
import { observer } from 'mobx-react';

import { PayerOnboardingMerchantInfo } from '../../payer-onboarding-generated';
import { ModalHeader, ModalContents } from '../../../WebGiving/components/modal/modal';
import * as style from './onboarding-info-modal.less';

export interface IOnboardingInfoModalProps {
	merchantInfo: PayerOnboardingMerchantInfo;
}

export class OnboardingInfoModalHeader extends React.Component {
	render() {
		return <ModalHeader text="Why create an account?" />;
	}
}

@observer
export class OnboardingInfoModalContent extends React.Component<IOnboardingInfoModalProps, {}> {
	public render() {

		const {merchantInfo: {TradingName, PaymentLabel}} = this.props;
		return (
			<ModalContents>
				<div className={`lead ${style.lead}`}>
					<p>
						Creating an account makes it easier than ever for you to {PaymentLabel.VerbLowerCase} and saves {TradingName} time. With your account, you can:
					</p>
					<ul>
						<li>Schedule recurring {PaymentLabel.NounPluralLowerCase}</li>
						<li>Track your {PaymentLabel.NounLowerCase} history</li>
						<li>Manage your payment methods</li>
					</ul>
					<p>What's the best part of having an account? It will take you less than ten seconds to {PaymentLabel.VerbLowerCase} from any device! It's that simple.</p>
				</div>
			</ModalContents>
		);
	}
}
